import { alpha, Box, darken } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { BaseModalComponent } from "../../../../../../../common/BaseModalComponent";
import { EventItem } from "./EventItem";
import { EventJobModal } from "./EventJobModal";

export const SingleEventCard = ({ arg, isFromJob }) => {
  const triggerRef = useRef(null);
  const containerRef = useRef(null);

  const { extendedProps } = arg.event;
  const { color, jobId } = extendedProps;
  const eventInstanceKey = arg.event?.id || arg.event?.extendedProps?.event?.uid || arg.event?.startStr || "event";

  const baseColor = color || "#6b7280";
  const barColor = darken(baseColor, 0.35);
  const hoverBg = alpha(baseColor, 0.22);
  const border = alpha(baseColor, 0.35);

  const [metrics, setMetrics] = useState({ width: 100, height: 30 });

  useEffect(() => {
    if (!containerRef.current) return;

    const ro = new ResizeObserver((entries) => {
      const rect = entries[0].contentRect;
      setMetrics({ width: rect.width, height: rect.height });
    });

    ro.observe(containerRef.current);
    return () => ro.disconnect();
  }, []);

  const isUltraSmall = metrics.height < 20;
  const paddingY = isUltraSmall ? 0.3 : 0.8;
  const paddingLeft = isUltraSmall ? 1 : 1.8;
  const scaleHover = isUltraSmall ? "none" : "scale(1.01)";
  const borderRadius = isUltraSmall ? 1 : 1.5;

  return (
    <>
      <Box
        ref={containerRef}
        onClick={() => {
          if (!isFromJob) triggerRef.current?.click?.();
        }}
        sx={{
          position: "relative",
          p: paddingY,
          pl: paddingLeft,
          width: "100%",
          borderRadius,
          bgcolor: "var(--fx-surface-base, #FFFFFF)",
          border: `1px solid ${border}`,
          color: "var(--fx-surface-text, #0F172A)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          cursor: isFromJob ? "default" : "pointer",
          transition: "all 0.15s ease",
          boxSizing: "border-box",

          "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
            width: 4,
            bgcolor: barColor,
            borderTopLeftRadius: borderRadius,
            borderBottomLeftRadius: borderRadius,
          },

          "&:hover": isFromJob
            ? {}
            : {
                bgcolor: hoverBg,
                transform: scaleHover,
                boxShadow: `0 0 0 1px ${border}`,
              },
        }}
      >
        <EventItem arg={arg} />
      </Box>

      <BaseModalComponent
        defaultSizes={{ width: "600", height: "1000" }}
        modalLabel={`Job ${jobId}`}
        modalKey={`Jobs-Calendar-${jobId}-${eventInstanceKey}`}
        defaultFullscreen={false}
        elementTrigger={
          <button
            ref={triggerRef}
            type="button"
            style={{
              position: "absolute",
              left: -99999,
              top: -99999,
              pointerEvents: isFromJob ? "none" : "auto",
            }}
          />
        }
      >
        <EventJobModal arg={arg} />
      </BaseModalComponent>
    </>
  );
};
